import { FunctionComponent } from "react";
import { DatePicker as AntDatePicker } from "antd";
import { CalendarIcon } from "@icons/CalendarIcon";
import { ExternalIcon } from "@icons/ExternalIcon";
import dayjs from "dayjs";
import "./BaseDatePicker.css";

const { RangePicker } = AntDatePicker;

// Allow all props from Ant Design's RangePicker except for the ones we override
type BaseDatePickerProps = Omit<
  React.ComponentProps<typeof RangePicker>,
  "minDate" | "suffixIcon" | "separator"
>;

const BaseDatePicker: FunctionComponent<BaseDatePickerProps> = ({
  ...rest
}) => {
  return (
    <RangePicker
      {...rest}
      minDate={dayjs()}
      suffixIcon={<CalendarIcon size={20} />}
      separator={<ExternalIcon svgName="arrow-full" size={16} />}
    />
  );
};

export { BaseDatePicker };
